<div class="travel-loader-cont {{classType}}" [class.desktop]="!isMobile">
  <div class="img-cont">
    <ng-lottie
      width="250px"
      height="250px"
      [options]="options"
      [styles]="styles">
    </ng-lottie>
  </div>
</div>